var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminView',[_c('router-link',{staticClass:"back-link",attrs:{"to":{ name: 'ProgramsList' }}},[_vm._v("< Retour")]),_c('h1',{staticClass:"title-1"},[_vm._v("Programmes - Messages audio")]),_c('ProgramAudioFilesForm',{attrs:{"audioFiles":_vm.audioFiles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }